// 画面レイアウト
import header from '@/components/organisms/TheHeader'
import footer from '@/components/organisms/TheFooter'
import sidebar from '@/components/organisms/TheSidebar'

// ------------------------------------------------------------
// 管理画面 NEO連携
// ------------------------------------------------------------
// 管理画面：desknet's NEO 接続設定
import NeoConnectionSetting from '@/components/pages/admin/envsettings/NeoConnectionSetting'
// 管理画面：AppSuiteデータ連携設定
import AppsuiteJobs from '@/components/pages/admin/appsuitejobs/Index'
import AppsuiteJobsList from '@/components/pages/admin/appsuitejobs/List'
import AppsuiteJobsEdit from '@/components/pages/admin/appsuitejobs/Edit'

// ------------------------------------------------------------
// 管理画面 NEO連携 isAdminPage: true
// ------------------------------------------------------------
export default [
  // desknet's NEO 接続設定
  {
    path: '/admin/neo-connection-settings',
    name: 'NeoConnectionSetting',
    meta: {
      isAdminPage: true,
      isReloadGuardPage: true
    },
    components: {
      header,
      sidebar,
      footer,
      content: NeoConnectionSetting
    }
  },
  // AppSuiteデータ連携設定
  {
    path: '/admin/appsuite-jobs',
    meta: {
      isAdminPage: true
    },
    components: {
      header,
      sidebar,
      footer,
      content: AppsuiteJobs
    },
    children: [
      // 一覧画面
      {
        path: '',
        name: 'appsuite-job',
        component: AppsuiteJobsList
      },
      // 作成画面
      {
        path: 'add',
        name: 'appsuite-job-add',
        meta: {
          isReloadGuardPage: true
        },
        component: AppsuiteJobsEdit
      },
      // 変更画面
      {
        path: ':id/edit',
        name: 'appsuite-job-edit',
        meta: {
          isReloadGuardPage: true
        },
        component: AppsuiteJobsEdit,
        props: true // $route.params.idをpropsに引き渡す
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.neo.js